import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-data-pagination',
  templateUrl: './data-pagination.component.html',
  styleUrls: ['./data-pagination.component.scss']
})
export class DataPaginationComponent  {
  @Input() totalItems: number = 0;
  @Input() pageSize: number = 5;
  @Input() currentPage: number = 1;

  @Output() pageChange = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  onPageChange(page: number): void {
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    }
  }

  onItemsPerPageChange(itemsPerPage: number): void {
    this.pageSize = itemsPerPage;
    this.itemsPerPageChange.emit(this.pageSize);
  }
}
